import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    height: "80vh",
  },
  search: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "8px",
  },
  table: {
    padding: 0,
    marginTop: 2,
    border: "1px solid #ccc",
    "& th, & td": { border: "1px solid #ccc" },
  },
  tableCell: {
    padding: 0,
    textAlign: "center",
  },
};
